export const animation = {
  pageExitDuration: 1,
  pageEntryDuration: 1.4,
  siteLoadDelay: 0.3,
  siteLoadDuration: 0.3,
};
